/* eslint complexity: ["error", 7] */
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {Dropdown, DropdownItem} from '@homeaway/react-dropdown';
import classNames from 'classnames';
import './FlagDropdown.less';

class FlagDropdown extends Component {
    static propTypes = {
        id: PropTypes.string,
        countryCode: PropTypes.string,
        flagData: PropTypes.arrayOf(PropTypes.shape({
            cc: PropTypes.string,
            masks: PropTypes.array,
            name: PropTypes.string,
            phoneCode: PropTypes.string
        })),
        onChange: PropTypes.func,
        showCountrySelect: PropTypes.bool
    }

    static defaultProps = {
        flagData: [],
        onChange: () => {},
        showCountrySelect: true
    }

    constructor(props) {
        super(props);

        this.handleKeyboardEvents = this.handleKeyboardEvents.bind(this);
        this.handleListItemSelect = this.handleKeyboardListItemEvents.bind(this);
    }

    /* eslint-disable-next-line complexity */
    handleKeyboardEvents(e) {
        // find the element that currently has focus
        let focusedElement = document.activeElement;
        // check to see if key pressed is a letter
        if (e.which >= 65 && e.which <= 90 || e.which >= 97 && e.which <= 122) {
            // find the first country alphabetically that starts with that letter
            let matchingCountryObject = this.findByFirstChar(e.which);
            if (matchingCountryObject) {
                // give the matching li focus
                let classNameLookUp = `${matchingCountryObject.cc} ${matchingCountryObject.phoneCode}`;
                this.flagDropdown.getElementsByClassName(classNameLookUp)[0].focus();
            }
        }

        // if user presses up arrow and focused element is an li in the flag dropdown and its not the first one, give previous sibling the focus
        if (e.which === 38 && focusedElement.className.indexOf('react-input-tel__dropdown-item') !== -1 && focusedElement.previousSibling) {
            focusedElement.previousSibling.focus();
        }

        // if user presses down arrow and focused element is an li in the flag dropdown and its not the last one, give next sibling the focus
        if (e.which === 40 && focusedElement.className.indexOf('react-input-tel__dropdown-item') !== -1 && focusedElement.nextSibling) {
            focusedElement.nextSibling.focus();
        }
    }

    handleKeyboardListItemEvents(e, data) {
        // if user presses enter or space and the focused element is an li item in the flag dropdown, change the selected country
        if (e.which === 13 || e.which === 32) {
            e.preventDefault();
            this.props.onChange(e, data);
        }
    }

    findByFirstChar(charCode) {
        const array = this.props.flagData;
        const length = array.length;
        let letterPressed = String.fromCharCode(charCode).toUpperCase();

        for (let i = 0; i < length; i++) {
            if (array[i].name[0].toUpperCase() === letterPressed) {
                return array[i];
            }
        }

        return null;
    }

    render() {
        const {
            id,
            countryCode,
            flagData,
            onChange,
            showCountrySelect
        } = this.props;
        const dropdownClasses = classNames({
            'react-input-tel__dropdown': true,
            'show-dropdown': showCountrySelect
        });

        return (
            <div
                role="presentation"
                onKeyDown={this.handleKeyboardEvents}
                ref={(el) => {
                    /* istanbul ignore next */
                    this.flagDropdown = el;
                }}
            >
                <Dropdown
                    srOnlyLabel
                    label={countryCode}
                    buttonChildren={countryCode ? <i className={`flag-${countryCode}`}/> : <div className="react-input-tel__dropdown-no-cc" />}
                    id={id}
                    className={dropdownClasses}
                    maxHeight={200}
                >
                    {flagData.map((data) => {
                        let dropdownItemClassName = classNames(`${data.cc} ${data.phoneCode}`, 'react-input-tel__dropdown-item');

                        return (
                            <DropdownItem
                                className={dropdownItemClassName}
                                text={<a><i className={`react-input-tel__dropdown-item-flag flag-${data.cc}`}/><span className="react-input-tel__dropdown-item-country-name">{`${data.name}`}</span><span className="react-input-tel__dropdown-item-phone-code">{`(+${data.phoneCode})`}</span></a>}
                                key={`${data.cc}`}
                                onClick={(e) => onChange(e, data)} // eslint-disable-line react/jsx-no-bind
                                onKeyDown={(e) => this.handleKeyboardListItemEvents(e, data)} // eslint-disable-line react/jsx-no-bind
                                tabIndex="0"
                                href="#"
                            />
                        );
                    })}
                </Dropdown>
            </div>
        );
    }
}

export default FlagDropdown;
